import { Button, notification } from "antd";
import useStore from "../../store/useStore";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import editDark from "./../../assets/images/edit-dark.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { referPlanToPatient, registerPatient } from "./service";
import { useState } from "react";

const PatientSummary = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { patientCondition, patientCareProgram, mobileNumber, patientName } =
    state || {};
  const { doctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
    setDoctorDetails: state.setDoctorDetails,
  }));

  const { accessCode = "", clinicRefCode = "" } =
    doctorDetails?.user?.myT || {};
  const { b2cId = "" } = doctorDetails?.user || {};
  const [referLoader, setReferLoader] = useState(false);
  const summaryData = [
    {
      id: "condition",
      label: "Condition",
      value: patientCondition?.medical_condition_name,
    },
    {
      id: "carePlan",
      label: "Selected Care Plan",
      value: patientCareProgram?.plan_name,
    },
    {
      id: "patientNumber",
      label: "Patient’s Mobile Number",
      value: mobileNumber,
    },
    {
      id: "patientName",
      label: "Patient’s Name",
      value: patientName,
    },
  ];

  const editPatientSummary = (index: number) => {
    switch (index) {
      case 1:
        navigate("/patient-condition", { state: state });
        break;
      case 2:
        navigate("/patient-care-program", { state: state });
        break;
      case 3:
        navigate("/patient-phone-number", { state: state });
        break;
      case 4:
        navigate("/patient-name", { state: state });
        break;
    }
  };

  const referPlan = async () => {
    setReferLoader(true);
    const registerPatientRes: any = await registerPatient({
      contact_no: mobileNumber,
      access_from: "Doctor",
      access_code: accessCode,
      medical_condition_group_id: patientCondition?.medical_condition_group_id,
      name: patientName,
      source: "TatvaLite",
      clinic_ref_code: clinicRefCode,
    });
    if (registerPatientRes?.code === "1") {
      const { patient_id, name, contact_no, email, dob } =
        registerPatientRes?.data;
      const referPlanToPatientRes: any = await referPlanToPatient({
        patientId: registerPatientRes?.data?.patient_id,
        b2cId,
        planMasterId: patientCareProgram?.plan_master_id,
      });
      if (referPlanToPatientRes?.code === 1) {
        navigate("/congratulations", {
          state: {
            ...state,
            patient_id,
            name,
            contact_no,
            email,
            dob,
          },
        });
      } else {
        notification.error({
          message: referPlanToPatientRes?.message,
        });
      }
    } else {
      navigate("/patient-already-referred", {
        state: state,
      });
    }
    setReferLoader(false);
  };

  const continueBtnHandler = async () => {
    referPlan();
  };

  const backBtnHandler = () => {
    navigate("/patient-name", {
      state: state,
    });
  };

  return (
    <div className="p-6">
      <div className="flex items-start font-semibold gap-x-2 pb-5">
        <img
          height={22}
          width={22}
          src={arrowLeft}
          alt="arrow-left"
          onClick={backBtnHandler}
        />
        <span> Patient's Summary</span>
      </div>
      <div className="flex flex-col gap-y-4">
        {summaryData.map((item, index) => (
          <div
            key={index}
            className="p-4 border border-[#DCE4E8] shadow rounded-2xl flex gap-x-2 items-start w-[calc(50%-1rem)] justify-between min-h-20 cursor-pointer"
            style={{ width: "100%" }}
            onClick={() => editPatientSummary(index + 1)}
          >
            <div className="flex flex-col items-start">
              <div className="text-[#5A6774] font-normal text-sm">
                {item.label}
              </div>
              <span className="text-base text-left font-semibold">
                {item.value}
              </span>
            </div>
            <img src={editDark} alt="edit" />
          </div>
        ))}
      </div>
      <div className="w-full fixed bottom-0 left-0">
        <div className="mx-auto max-w-[1280px] w-full p-6">
          <Button
            type="primary"
            className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
            onClick={continueBtnHandler}
            loading={referLoader}
          >
            Refer Care Plan
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PatientSummary;
